/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
class a {
  /**
   * @hidden
   */
  constructor(t, e, n, r) {
    this.target = t, this.prevIndex = e, this.nextIndex = n, this.newState = r;
  }
}
export {
  a as SortableOnDragEndEvent
};
